import {
	ADD_PROFORMA_FORM_OPTIMISTICALLY,
	DISCARD_PROFORMA_CHANGES,
	FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS,
	MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL,
	REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS,
	SAVE_CHANGES_START,
	SAVE_CHANGES_SUCCESS,
	SET_REQ_TYPE_CONTEXT,
	SYNC_PROFORMA_FORM_START,
	SYNC_PROFORMA_FORM_SUCCESS,
	type Action,
	type AddProformaFormOptimisticallyAction,
	type AddProformaFormOptimisticallyPayload,
	type DiscardProformaChangesAction,
	type FetchProformaReqTypeConfigSuccessAction,
	type FetchProformaReqTypeConfigSuccessPayload,
	type MarkProformaReqTypeFormForRemovalAction,
	type MarkProformaReqTypeFormForRemovalPayload,
	type RemoveProformaReqTypeFormSuccessAction,
	type SaveChangesStartAction,
	type SaveChangesSuccessAction,
	type SetReqTypeContextAction,
	type SetReqTypeContextPayload,
	type SyncProformaFormStartAction,
	type SyncProformaFormSuccessAction,
} from './types.tsx';

export const addProformaFormOptimistically = (
	payload: AddProformaFormOptimisticallyPayload,
): AddProformaFormOptimisticallyAction => ({
	type: ADD_PROFORMA_FORM_OPTIMISTICALLY,
	payload,
});

export const discardProformaChanges = (): DiscardProformaChangesAction => ({
	type: DISCARD_PROFORMA_CHANGES,
});

export const fetchProformaReqTypeConfigSuccess = (
	payload: FetchProformaReqTypeConfigSuccessPayload,
): FetchProformaReqTypeConfigSuccessAction => ({
	type: FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS,
	payload,
});

export const markProformaReqTypeFormForRemoval = (
	payload: MarkProformaReqTypeFormForRemovalPayload,
): MarkProformaReqTypeFormForRemovalAction => ({
	type: MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL,
	payload,
});

export const removeProformaReqTypeFormSuccess = (): RemoveProformaReqTypeFormSuccessAction => ({
	type: REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS,
});

export const saveChangesStart = (): SaveChangesStartAction => ({
	type: SAVE_CHANGES_START,
});

export const saveChangesSuccess = (): SaveChangesSuccessAction => ({
	type: SAVE_CHANGES_SUCCESS,
});

export const setReqTypeContext = (payload: SetReqTypeContextPayload): SetReqTypeContextAction => ({
	type: SET_REQ_TYPE_CONTEXT,
	payload,
});

export const syncProformaFormStart = (): SyncProformaFormStartAction => ({
	type: SYNC_PROFORMA_FORM_START,
});

export const syncProformaFormSuccess = (): SyncProformaFormSuccessAction => ({
	type: SYNC_PROFORMA_FORM_SUCCESS,
});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports
export {
	ADD_PROFORMA_FORM_OPTIMISTICALLY,
	FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS,
	DISCARD_PROFORMA_CHANGES,
	REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS,
	MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL,
	SAVE_CHANGES_START,
	SAVE_CHANGES_SUCCESS,
	SET_REQ_TYPE_CONTEXT,
	SYNC_PROFORMA_FORM_START,
	SYNC_PROFORMA_FORM_SUCCESS,
};
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { SyncProformaFormStartAction, SyncProformaFormSuccessAction };
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Action };
